module.exports = __webpack_public_path__ + "img/down4-en.f06fad6f.png";